module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("“So, I’ve been dating a new guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I blink at my best friend, Rachel, and then shake my head. “And you didn’t tell me?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She flushes. “Well, it’s only one date, but he seems really sweet. He’s so cute, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Details.” I grin, shifting on my bar stool and sipping my drink.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Well, he’s an environmentalist.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("My brows shoot up. “Like he looks after trees and stuff?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She giggles. “I think so. Anyway, it was kind of weird because we just sort of bumped into each other and he started talking to me. He was so charming. Next thing I knew I was going out with him. He was so interested in my life, you know? Asking me about my family and friends. It was nice to be heard.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“He sounds like a keeper.” I smile. “When do you see him again?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Soon, I hope. I didn’t get his number, but he said he’d call me.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“He’ll totally call you. How could he not, you’re smoking!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She laughs, but something over my shoulder catches her eye.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Don’t look now, Lara.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I glance at my best friend, who is staring over my shoulder with a tight expression on her face. I begin turning only to have her hand lash out and catch my shoulder, spinning me back around. I scowl at her, narrowing my eyes with confusion. She can be so dramatic at times.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Seriously,” she says. “Don’t look. It’ll only make you mad.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“What’re you talking about?” I ask, pulling my shoulder free from her grip.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Noah just walked in.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I freeze midturn, and my heart pounds so loud I can feel it in my ears. Noah. A man I haven’t seen in three months, a man who has tortured my mind and owned my heart for so many years. A man who broke my heart. The very idea that I’m about to see him again sends blind terror coursing through my body. I’m not ready. Not even close.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I didn’t know he was back in town,” I whisper, my voice shaky. “Where? I can’t see him, Rach!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“He is and he’s not alone,” Rachel says, her face sympathetic.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("It comes out as a squeak, a broken, pathetic squeak. He’s not alone? He’s moved on already? That hurts, more than I’m willing to admit. We didn’t part on good terms, sure, but he loved me. At least, he said he did. I know I haven’t been able to talk to him yet, but how could he move on so quickly? Pain explodes in my chest, and I lift my drink and take a long sip to cover it from my best friend, who is glaring in his general direction.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Deep down, I know the answer to my question. Ladies’ man. That’s what my friends told me when I started dating him. Not to be trusted. I should have listened.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Do you want to go?” she asks, turning back to me. “Or do you want to talk to him?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I glare at her.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She puts her hands up. “Sorry, I just think maybe if you two talked then things will clear up and—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Why should I to talk to him? How would that help?” I whisper, hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Her eyes get soft. “Because I love you and you’re hurting. It’s been months now. I think if you talk to him, you’ll be able to move on.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“He hurt me.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I know. But you—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I just want to go, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She smiles sadly, accepting my decision. “Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I finish my drink and start toward the back exit with Rachel by my side.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Lara?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I jerk at the sound of his deep, masculine voice. God, I’ve missed his voice, almost as much as I’ve missed him. I swallow the lump forming in my throat and slowly turn to see Noah standing behind me, looking down, eyes locking on mine. I shiver at the intensity in his gaze. He always had that power over me. He was the dark to my light, the hard to my soft. I might have been different when we first met, but he had this way about him that could control me like a puppet with just one look. And he’s giving me that look right now.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Noah,” I say, my voice small.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("His eyes flicker over my face before settling back on mine. “It’s been a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Three months, two days, to be exact. Not like I was counting.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He tilts his head to the side and studies me again. I shift uncomfortably, avoiding his eyes. He looks amazing tonight, not that I’m surprised by that. He’s always towered over my tiny five-foot frame. His big body is easily six feet tall, and he’s built like a statue. Muscles on every part of his perfect body. His eyes are as intense as they always were, a steel gray that pierces straight into my soul. His hair is longer than I remember, but the dark-brown locks seem even more rebellious now as they fall over his face.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“How have you been?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I finally get the courage to look him in the eye. “Good, great.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I’m a liar.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He knows it.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You look good, Lara.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I used to love how it sounded when he said my name, the way it rolled off his tongue. The way his husky voice coiled around it and made it his.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I hate it now.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Thanks,” I say, my voice barely above a whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’ve missed you. I’ve been meaning to get in touch since I got back. I was hoping we could talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Noah told me he fell in love with me because I was sweet, sassy, and gorgeous—a rare mixture that was hard to find. He said I was the kind of woman that made a man’s heart melt, that made him want to protect her and love her for as long as he possibly could, yet at the same time wasn’t afraid to stand up for herself and speak her mind. At least that was how I used to be. Until I learned very quickly that doing that, being that kind of woman, would only lead to people getting hurt, or worse. There are times when I miss that version of myself. Maybe I should talk to him. Maybe I’m ready to hear him out. Maybe … ")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Noah?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("A gorgeous blond woman sidles up beside him and I look away, unable to witness him with another girl. Even the glance I got of her has my heart ripping to shreds. The exact opposite of me. Tall, blond, confident. Seeing her makes me realize I’m still not ready to talk to him.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Come on,” Rachel says, tugging my arm and giving Noah a look. “You don’t deserve this.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Noah glares at her. “This isn’t any of your business, Rachel.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“She’s my friend, it’s my business.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Ah,” the blonde says. “Do we know you?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No, you don’t know me,” Rachel throws in her direction. “I wouldn’t bother with the likes of you. Come on, Lara. Let’s go.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She takes my hand and pulls me toward the crowd that we have to make our way through to get to the door. Noah steps forward and reaches out, grabbing my arm and stopping me before we manage even five steps. Electricity runs through my body at his touch, and I want to scream, hating that it still affects me so heavily. He steps up close and I can feel him, smell him; my entire body becomes alert with his presence.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Can’t avoid me forever,” he says, his voice low.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Let me go,” I plead, pulling my arm from his. “Just leave me alone, Noah.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“If you would’ve answered my calls and heard me out, I might’ve been able to leave you alone, but considering you didn’t, I can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I spin around and finally, really, look at him. Seeing him knocks the breath from my lungs. I forgot how utterly breathtaking he is. “That’s probably because I don’t want to hear your excuses. I just need you to leave me alone. You’re clearly busy.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Lara…”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No, Noah. Just stop.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Lara…”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Who is the woman?” I say, my voice wavering. “You want to talk to me, but it looks like you’ve already moved on.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“We’re here meeting a friend. She’s not my date,” he snaps.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You actually expect me to believe that?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I expect you to give me the chance to speak to you. After everything that happened with Nanna—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("His mention of Nanna reminds me of the moment I changed from being a loudmouthed, confident girl to this quiet, damaged woman I am now. Just a few years ago, I was overly confident. I was loud, boisterous, and occasionally a little too much, but I still had a good heart. Noah loved me for me, but my nanna always told me that my mouth would get me into trouble—and she was right. Except it was she who paid the price for my in-your-face attitude. After that day, I slowly lost who I was, my confidence especially. I’m no longer the woman Noah remembers.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Thinking about that night has my heart clenching.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Maybe we should go the other way,” Nanna says, clutching my hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I stare at the group of teenagers laughing and kicking over trash cans up ahead. I scoff and squeeze her hand. “No way. They’re just acting like idiots. We shouldn’t have to move. We’ll just walk past, it’ll be fine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Lara, I have a bad feeling about this. Let’s go the other way,” she pleads.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Nanna always worries. If we turn around, we’re looking at adding another twenty minutes to our trip. There is no reason we shouldn’t be able to walk past this group of kids without problems. I won’t let anything happen to her.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“We’ll be fine. They’re just a bunch of kids, Nanna.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("We walk toward them, paying them no attention, her hesitantly, me not so much. When they notice us, a brown-haired, scruffy teen steps forward. He looks like he’s maybe seventeen, possibly a little older. His face is covered in pimples and his hair is falling over his face. He’s skinny and tall, hardly threatening, but clearly cocky.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“What have we got here? Evening, ladies.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I ignore them and keep moving.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“What?” the teenager scoffs. “We’re not good enough to say hello to?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I turn and stare at him. “I wouldn’t say hello to you if you were the last person on the planet and I needed to talk to you to save humanity,” I say, studying him. “Now go home to bed and stop kicking trash cans around like a bunch of idiots.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Be careful,” he warns, stepping forward and in my way. “I’m not a very nice person and I don’t like smart-mouthed chicks like you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("God, who does this dude think he is? I wave a hand in his face casually. “Run along and play with your toys—it’s past your bedtime.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("All the other boys laugh.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("His face burns bright and I know I’ve embarrassed him. Well, that’s what you get when you pick on people walking home minding their own business.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Just stop,” Nanna pleads, tugging my hand. “Just ignore them, Lara. They’re not worth it. Let’s go the other way.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“I don’t like being spoken to like that,” he says, stepping closer, puffing his chest out. No doubt for the benefit of his friends.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I let Nanna’s hand go and step in front of her, crossing my arms. “Neither do I. Now, we’re walking home and doing nothing, and you’re causing problems where problems don’t exist. Why don’t you move the hell out of the way?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Or what?” he challenges. He’s high as a kite, his eyes bloodshot. How did I not notice that before?")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Or I’ll make you,” I snap.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Lara, please,” Nanna begs.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Don’t upset your grannie, Lara. I can only imagine what could happen to her out here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I bristle. “If you so much as touch a hair on her head I’ll make you wish you didn’t. Now fucking move.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“I really, really don’t like your mouth,” he growls.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("God, this guy just can’t take a hint.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“And I really don’t like pimply-faced, limp-dicked little teenagers who think they’re cool because they can run around smoking pot and kicking trash cans over. Do you feel tough? I can almost guarantee you don’t get laid and so this is the best you can do for yourself.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Lara!” Nanna cries. “Come on.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The boy’s eyes flare and he nods to his friends, who all step closer to me. Fear courses down my spine as I realize I’m surrounded. I keep my head held high and hold the boy’s eyes. I won’t back down for a bunch of teenagers trying to scare me.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Please,” Nanna says. “Don’t hurt her. We’re on our way. I have cash, if you want. Just leave us alone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("She tries to step closer but one of the boys turns and shoves her. In slow motion she falls to the ground and a loud crack radiates through the still night. Blood pours out onto the pavement around her head. “No,” I scream. “Nanna!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Holy shit, you stupid fucker,” the boy yells. “Run.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("They disappear into the night and I’m already on my hands and knees, crawling toward Nanna, the skin on my knees tearing as I get closer. “Nan?” I cry, reaching her. She’s covered in blood. She’s not moving. Oh God, what have I done? What the hell have I done? I take her face in my hands, shaking her gently.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Nanna, please wake up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("So much blood. I try to find where she hit her head, but there is so much blood I can’t find anything.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A car slows and a man jumps out, I barely notice him. “I saw it all. Are you okay?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“There were these boys,” I sob. “One of them pushed my nanna and she’s hurt. Please.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“I’m going to call nine-one-one.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Nanna,” I sob, tears running down my cheeks. “God, I’m so sorry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("This is all my fault. All my fault. I should have listened to her and turned around or kept walking and just been polite to them. She told me my mouth would get me into trouble one day, and she was right. What have I done? Oh God, what have I done?")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Nanna,” I sob. “Please wake up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Please. I’m so sorry.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I snap myself out of the memory that haunts me daily and look back to Noah, who is studying me. His eyes have softened, as though he can read my mind.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Fine,” I say. “I’m going to go now.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Were you thinking about her?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I flinch. His eyes grow softer. He liked my nan. She was one of few people who believed he was good enough for me and wouldn’t hurt me. She saw the good in Noah, and he adored her for it.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’m sorry, I can’t do this. I have to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I rush out before he has the chance to say any more.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Mostly because I can’t bear to hear it.")]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("My eyes follow Lara as she rushes out of the club. Her face is scrunched in pain and her tiny form shoves through the people with a weakness that excites me. She’s timid,")]), _vm._v(" pathetic "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("even. I move my eyes to Noah, watching her go. He’s a good mix of angry and desperate. Exactly what I want. He’s looking at her like he wants to protect her while at the same time wanting to beat her.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("She frustrates him. She’s fragile and weak. He’s strong and determined.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The perfect combination for my game.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The quiet little mouse and the man who will stop at nothing to protect her.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I’ve been watching them long enough, setting up my game, to know I have found the perfect pieces. They have no idea. Not a single clue how many times I’ve infiltrated their lives without their ever knowing it. Stupid. I can’t wait to see their faces when they find out just how close I’ve been all this time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("They’re going to wish they never met me by the time I’m done with them.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba8dfc14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 69
// module chunks = 0